import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";


const HowSubmit = () => {
  return (
    <Container>

    <h2 className="display-6 fw-bold my-4">
    Peer review
    </h2>
    <hr />
   
      <p className="joab-common-para my-2 ">
      All Green Publication journals operate a double blind review process. All contributions will be initially assessed by the editor for suitability for the journal. Papers deemed suitable are then typically sent to a minimum of two independent expert reviewers to assess the scientific quality of the paper. The Editor is responsible for the final decision regarding acceptance or rejection of articles. The Editor’s decision is final. 
      </p>
   
    

  </Container>
  );
};

export default HowSubmit;
